__turbopack_context__.v({
  "details": "work-edition-info-module-scss-module__Jsjevq__details",
  "panel": "work-edition-info-module-scss-module__Jsjevq__panel",
  "professionalReviews": "work-edition-info-module-scss-module__Jsjevq__professionalReviews",
  "root": "work-edition-info-module-scss-module__Jsjevq__root",
  "tabs": "work-edition-info-module-scss-module__Jsjevq__tabs",
  "u-animation-bounce": "work-edition-info-module-scss-module__Jsjevq__u-animation-bounce",
});
